import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import Library from './pages/Library';
import Download from './pages/Download';
import Search from './pages/Search';
import Contact from './pages/Contact';
import Support from './pages/Support';
import './styles/App.css';

function App() {
  const [lang, setLang] = useState('fr');

  return (
    <Router>
      <div className="app">
        <header className="header">
          <div className="header-content">
            <Link to="/" className="logo">
              <span className="logo-icon">🕌</span>
              <span className="logo-text">Islam & Life</span>
            </Link>
            <nav>
              <Link to="/">{lang === 'fr' ? 'Accueil' : 'Home'}</Link>
              <Link to="/library">{lang === 'fr' ? 'Feuilleter' : 'Browse'}</Link>
              {/* RECHERCHE CACHÉE - décommenter pour activer */}
              {/* <Link to="/search">{lang === 'fr' ? 'Rechercher' : 'Search'}</Link> */}
              <Link to="/download">{lang === 'fr' ? 'Télécharger' : 'Download'}</Link>
              <Link to="/contact">Contact</Link>
            </nav>
            <div className="lang-switch">
              <button onClick={() => setLang('fr')} className={lang === 'fr' ? 'active' : ''}>FR</button>
              <button onClick={() => setLang('en')} className={lang === 'en' ? 'active' : ''}>EN</button>
            </div>
          </div>
        </header>

        <main>
          <Routes>
            <Route path="/" element={<Home lang={lang} />} />
            <Route path="/library" element={<Library lang={lang} />} />
            <Route path="/search" element={<Search lang={lang} />} />
            <Route path="/download" element={<Download lang={lang} />} />
            <Route path="/contact" element={<Contact lang={lang} />} />
            <Route path="/support" element={<Support lang={lang} />} />
          </Routes>
        </main>

        <footer className="footer">
          <p>© 2026 Islam & Life - Abou Soumaya Al-ABDOULI</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
